import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import { GRADES, MALE } from './static-data'
import user from './user/index'
import vip from './vip'
import zujuan from './zujuan/index'
import pop from './pop'
import basket from './zujuan/basket'

Vue.use(Vuex)
let store = new Vuex.Store({
  modules: {
    common,
    user,
    vip,
    zujuan,
    pop,
    basket
  },
  state: {
    pageTransName: 'slide-left',
    provinceRemote: null,
    scrollTop: 0,
    scrollBottom: 0,
    requestMsg: '',
    device: {
      width: 0
    },
    grades: GRADES,
    male: MALE,
    incrementList: []
  },
  getters: {
    deviceWidth (state) {
      return state.device.width
    }
  },
  mutations: {
    updateDeviceWidth (state, val) {
      state.device.width = val
    },
    updateScrollTop (state, val) { // 计算滚动条距底部距离，用于上滑加载更多数据
      state.scrollTop = val
    },
    updateScrollBottom (state, val) { // 计算滚动条距底部距离，用于上滑加载更多数据
      state.scrollBottom = val
    }
  },
  actions: {
  }
})

export default store
